<template>
	<div></div>
</template>
<script setup>
import { onMounted, ref, watch, nextTick } from 'vue';
import { userLangStore } from '@/store/userLangStore';

const lang = userLangStore();
const lng = ref((localStorage.getItem('locale') || 'en'));

onMounted(
	async () => {
		window.chtlConfig = {
			chatbotId: "4544818115",
			variables: {
				ttlang: lng.value
			}
		}
		let chtlScript = document.createElement('script');
		chtlScript.setAttribute('data-id', '4544818115');
		chtlScript.setAttribute('id', 'chtl-script');
		chtlScript.setAttribute('src', 'https://chatling.ai/js/embed.js');
		document.head.appendChild(chtlScript);
	});

watch(() => lang.refreslang, async () => {
	await nextTick();
	lng.value = localStorage.getItem('locale');
});
</script>
<style scoped>
</style>